function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Log from '@deephaven/log';
import { ColorUtils } from '@deephaven/utils';
import { vsCheck } from '@deephaven/icons';
import { Button, DropdownMenu } from '@deephaven/components';
import { FormatStyleType, getLabelForStyleType, getBackgroundForStyleConfig, getColorForStyleConfig } from "./ConditionalFormattingUtils.js";
import "./StyleEditor.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('StyleEditor');
var DEFAULT_BACKGROUND = '#fcfcfa';
var DEFAULT_COLOR_LIGHT = '#f0f0ee';
var DEFAULT_COLOR_DARK = '#1a171a';
var DEFAULT_DROPDOWN_WIDTH = 200;
var DEFAULT_CALLBACK = () => undefined;
function StyleEditor(props) {
  var _config$customConfig$, _config$customConfig;
  var config = props.config,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? DEFAULT_CALLBACK : _props$onChange;
  var _useState = useState(config.type),
    _useState2 = _slicedToArray(_useState, 2),
    styleType = _useState2[0],
    setStyleType = _useState2[1];
  var _useState3 = useState((_config$customConfig$ = (_config$customConfig = config.customConfig) === null || _config$customConfig === void 0 ? void 0 : _config$customConfig.background) !== null && _config$customConfig$ !== void 0 ? _config$customConfig$ : DEFAULT_BACKGROUND),
    _useState4 = _slicedToArray(_useState3, 2),
    background = _useState4[0],
    setBackground = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isShown = _useState6[0],
    setShown = _useState6[1];
  var _useState7 = useState(DEFAULT_DROPDOWN_WIDTH),
    _useState8 = _slicedToArray(_useState7, 2),
    dropdownWidth = _useState8[0],
    setDropdownWidth = _useState8[1];
  var csContainer = useRef(null);
  var handleBackgroundChange = useCallback(e => {
    var value = e.target.value;
    log.debug('handleBackgroundChange', value);
    setBackground(value);
  }, []);
  var handleMenuClosed = useCallback(() => {
    if (isShown) {
      setShown(false);
    }
  }, [isShown]);
  var handleToggleClick = useCallback(() => {
    if (!isShown) {
      updateDropdownWidth();
    }
    setShown(!isShown);
  }, [isShown]);
  var styleOptions = useMemo(() => [FormatStyleType.NO_FORMATTING, FormatStyleType.POSITIVE, FormatStyleType.NEGATIVE, FormatStyleType.WARN, FormatStyleType.NEUTRAL, FormatStyleType.ACCENT_1, FormatStyleType.ACCENT_2, FormatStyleType.CUSTOM], []);
  function updateDropdownWidth() {
    if (csContainer.current) {
      setDropdownWidth(csContainer.current.getBoundingClientRect().width);
    }
  }
  useEffect(function updateTheme() {
    onChange({
      type: styleType,
      customConfig: {
        color: ColorUtils.isDark(background) ? DEFAULT_COLOR_LIGHT : DEFAULT_COLOR_DARK,
        background
      }
    });
  }, [onChange, styleType, background]);
  var renderOptions = useCallback(() => {
    var matchFound = false;
    var optionArray = [];
    var _loop = function _loop() {
      var option = styleOptions[index];
      var key = "option-".concat(index, "-").concat(option);
      matchFound = matchFound || option === styleType;
      optionArray.push(/*#__PURE__*/_jsxs(Button, {
        kind: "inline",
        className: "style-option-btn",
        onClick: () => {
          setStyleType(option);
          setShown(false);
        },
        style: {
          color: getColorForStyleConfig({
            type: option
          }),
          background: getBackgroundForStyleConfig({
            type: option
          })
        },
        children: [option === styleType && /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsCheck,
          className: "mr-2"
        }), option !== styleType && /*#__PURE__*/_jsx("span", {
          className: "mr-4"
        }), getLabelForStyleType(option)]
      }, key));
    };
    for (var index = 0; index < styleOptions.length; index += 1) {
      _loop();
    }
    return optionArray;
  }, [styleOptions, styleType]);
  var renderMenuElement = useCallback(() => /*#__PURE__*/_jsx("div", {
    className: "style-menu-container",
    role: "presentation",
    style: {
      width: dropdownWidth
    },
    children: /*#__PURE__*/_jsx("div", {
      className: "style-options",
      children: renderOptions()
    })
  }), [dropdownWidth, renderOptions]);
  return /*#__PURE__*/_jsxs("div", {
    className: "style-editor",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "mb-2",
      ref: csContainer,
      children: [/*#__PURE__*/_jsx("label", {
        className: "mb-0 mt-1",
        children: "Style"
      }), /*#__PURE__*/_jsxs(Button, {
        kind: "inline",
        className: "cs-dropdown custom-select",
        style: {
          color: getColorForStyleConfig({
            type: styleType
          }),
          background: getBackgroundForStyleConfig({
            type: styleType
          })
        },
        onClick: handleToggleClick,
        children: [getLabelForStyleType(styleType), /*#__PURE__*/_jsx(DropdownMenu, {
          isShown: isShown,
          actions: {
            menuElement: renderMenuElement()
          },
          popperOptions: {
            placement: 'bottom-start'
          },
          popperClassName: "style-dropdown-menu",
          onMenuClosed: handleMenuClosed,
          menuStyle: {
            maxWidth: '100rem'
          }
        })]
      })]
    }), styleType === FormatStyleType.CUSTOM && /*#__PURE__*/_jsxs("div", {
      className: "mb-2",
      children: [/*#__PURE__*/_jsx("label", {
        className: "mb-0",
        children: "Background"
      }), /*#__PURE__*/_jsx("input", {
        type: "color",
        value: background,
        className: "custom-select color-select",
        onChange: handleBackgroundChange
      })]
    })]
  });
}
export default StyleEditor;
//# sourceMappingURL=StyleEditor.js.map